
<template>
  <div class="greyactivitybackground" :class="
    mobile() ? 'activity-page-container-mobile' : 'activity-page-container'
  ">
    <AlertMessages v-if="alertValue" :alert-type="alertType" :alert-msg="alertMsg" @reset="alertValue = false" />
    <div class="fill-height fluid workflow pb-16" :class="mobile() ? 'px-8' : ''" v-if="!loading">
      <v-row justify="center" align="center" no-gutters>
        <v-col cols="12" class="mt-16 pb-0">
          <v-card v-if="showWarningUnpublishedChanges" color="greyactivitybackground" class="mx-auto text-right" elevation="0" max-width="500px" width="100%" data-testid="unpublished-chip">
            <v-chip class="ma-2" color="warning" outlined> {{ $t('unpublishedChanges') }}</v-chip>
          </v-card>
          <v-card color="#c8f0d7" class="mx-auto rounded-lg" max-width="500px" width="100%">
            <v-row class="py-3">
              <v-col cols="12" class="">
                <v-card-subtitle class="pa-0 text-center">
                  {{ $t("addPeopleToWorkflow") }}
                </v-card-subtitle>
              </v-col>
            </v-row>
          </v-card>
        </v-col>
      </v-row>
      <div v-if="workflowActions.length == 0" class="vertical"></div>
      <v-row justify="center" align="center" no-gutters v-if="workflowActions.length == 0">
        <v-col cols="12" class="mt-16 pb-0">
          <v-card class="mx-auto greyactivitybackground rounded-lg" elevation="0" max-width="500px"
            width="100%">
            <v-row class="py-3 mx-auto color-border" style="border-style: dashed">
              <v-col cols="12" class="ma-4">
                <draggable 
                  v-if="!loading" 
                  ref="dragArea" 
                  class="dragArea" 
                  style="max-width: 500px; width: 100%;" 
                  :list="workflowActions" 
                  group="blocks"
                  >
                </draggable> 
              </v-col>
            </v-row>
          </v-card>
        </v-col>
      </v-row>
      <v-row justify="center" align="center" no-gutters v-if="workflowActions.length > 0">
        <v-col cols="12">
          <v-expansion-panels style="max-width: 500px; width: 100%; " class="mx-auto" v-model="openedPanel">
        
            <draggable 
              v-if="workflowActions.length > 0 && !loading" 
              ref="dragArea" 
              class="dragArea" 
              style="max-width: 500px; width: 100%;" 
              :list="workflowActions" 
              group="blocks"
              :sort="true"
              handle=".handle"
              @end="sortDone"
              >
            
              <div v-for="(item, index) in workflowActions" :key="index" 
                class="mx-auto workflow-action " data-testid="workflow-action">
                <div class="d-flex">
                  <v-icon v-if="!item.attributes.is_deleted" class="handle mr-3">mdi-drag</v-icon>
                  <ShareItems 
                    style="width: 100%;" 
                    :class="{ 'first': index == 0, 'last': index == workflowActions.length - 1, 'pt-4' : !item.attributes.is_deleted }"
                    data-testid="action-workflow" 
                    @proceedSubmit="createWorkflowAction" 
                    @edit="editWorkflowAction" 
                    @afterDelete="afterDelete" 
                    @editAndSave="editWorkflowActionSaveWorkflow" 
                    @deleteAndSave="saveWorkflowWithoutRedirectAfterDeletion"
                    :index="index" 
                    :item-action="item" 
                    :type-action="item.attributes.type ? item.attributes.type : item.relationships['action-types'].meta.type" 
                    :activities-list="activities" 
                    :hubs-list="hubs" 
                    :delay-time="item.attributes.delay_duration ? Number(item.attributes.delay_duration) : 0" 
                    :delay-till-time="item.attributes.delay_till_time ? item.attributes.delay_till_time : null" 
                    :custom-subject="item.attributes.custom_subject ? item.attributes.custom_subject : ''" 
                    :custom-message="item.attributes.custom_message ? item.attributes.custom_message : ''" 
                    :event-title="item.attributes.event_title ? item.attributes.event_title : ''" 
                    :event-type="item.attributes.event_type ? item.attributes.event_type : 'digital'" 
                    :event-has-list="item.attributes.event_has_list ? item.attributes.event_has_list : false" 
                    :event-at="item.attributes.event_at ? item.attributes.event_at : null" 
                    :event-data="item.attributes.event_data ? item.attributes.event_data : { url: '' }" 
                    :event-tutors="item.attributes.event_tutors ? item.attributes.event_tutors : []" 
                    :event-reminders="item.attributes.event_reminders ? item.attributes.event_reminders : []" 
                    :key="updateAction+index" 
                    :update="updateAction"
                  >
                  </ShareItems>
                </div>
               
                <v-card v-if="item.attributes.is_broken && !item.attributes.is_deleted" class="broken-card rounded-lg py-3 px-15 ml-9" data-testid="broken-card">
                  <v-card-title class="title pa-0">
                    <v-icon color="error" style="position: absolute; top: 12px; left: 12px;">mdi-alert</v-icon>
                    <v-icon style="position: absolute; top: 12px; right: 12px;" @click="refreshWorkflowAction(item.id)" data-testid="reload-icon">mdi-reload</v-icon>
                    <p>{{ $t('infoBrokenActionTitle') }}</p>
                  </v-card-title>
                  <v-card-subtitle class="pa-0 pt-4">
                    {{ $t('infoBrokenActionSubtitle') }}:<br />
                    - {{ $t('infoBrokenActionText1') }} <br />
                    - {{ $t('infoBrokenActionText2') }}
                  </v-card-subtitle>
                </v-card>
              </div>
          </draggable>
          </v-expansion-panels>
        </v-col>
      </v-row>
      <v-row v-else align="center" class="mt-16" data-testid="empty-workflow">
        <v-col cols="12" sm="8" md="6" offset-sm="2" offset-md="3" align="center">
          <span class="text-h5 font-weight-bold text-center greytextlight--text">
            {{ $t("emptyBlockEditWorkflow") }}
          </span>
        </v-col>
      </v-row>
    </div>
    <v-navigation-drawer app permanent right clipped data-testid="navigation-drawer" width="300">
      <v-row class="ma-0">
        <v-col cols="4">
          <v-tooltip top>
            <template v-slot:activator="{ on }">
              <v-icon data-testid="discard-changes-icon" dense v-on="on" :disabled="disableButtons" @click="
                (dialogDraftVisible = true),
                (confirmationDialogTitle = $t(
                  'confirmationDialogTitleDiscardChanges'
                )),
                (confirmationDialogText = $t(
                  'confirmationDialogTextDiscardChanges'
                )),
                (confirmationDialogSubmitBtn = $t('discard'));
              confirmationDialogCancelBtn = $t('no');
                                ">
                mdi-backup-restore
              </v-icon>
            </template>
            <span>{{ $t("discardChanges") }}</span>
          </v-tooltip>
        </v-col>
        <v-col cols="8" align="right">
          <v-btn data-testid="save-button" class="rounded-xxl text-none px-3" color="success" :disabled="disableButtons"
            @click="saveWorkflowActions">
            {{ $t("publish") }}
          </v-btn>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12" align="center" class="my-4">
          <p class="text-center font-weight-bold mb-0">
            {{ $t("workflowActions") }}
          </p>
        </v-col>
      </v-row>
      <div :class="{'disabled-area' : disableButtons}">
        <div class="disabled-overlay" v-if="disableButtons"></div>
          <draggable 
            :list="listActionBlocks" 
            :group="!disableButtons ? { name: 'blocks', pull: 'clone', put: listActionBlocks } : {}" 
            @start="dragging = true;"
            @end="onEnd"
            :clone="dragDropBlockToPageLayout"
            :sort="false"
            data-testid="list-actions" 
            chosen-class="chosen-block"
          >
            <div v-for="(element, index) in listActionBlocks" :key="index" class="list-group-item ma-3 rounded-tl-xl rounded-bl-xl"
            :class="{
              first: index == 0,
              last: index == listActionBlocks.length - 1,
            }"
          >
            <v-card class="px-3 ma-0 rounded-lg" data-testid="action-card"
              @click="!disableButtons ? addBlockToLayout(element) : ''">
              <v-row>
                <v-col cols="3" class="border-class text-center rounded-tl-lg rounded-bl-lg" justify-center style="background: #e3e3e3">
                  <v-icon v-if="element.attributes.type == 'share_hub' || element.attributes.type == 'share_activity'" style="height: 100%"> mdi-share-variant </v-icon>
                  <v-icon v-else-if="element.attributes.type == 'delay_duration'" style="height: 100%"> mdi-timer-sand-complete </v-icon>
                  <v-icon v-else-if="element.attributes.type == 'delay_until'" style="height: 100%"> mdi-calendar-today </v-icon>
                  <v-icon v-else-if="element.attributes.type == 'custom_message'" style="height: 100%"> mdi-email-outline </v-icon>
                  <v-icon v-else-if="element.attributes.type == 'remove_from_hub' || element.attributes.type == 'remove_from_activity'" style="height: 100%"> mdi-account-remove-outline </v-icon>
                  <v-icon v-else-if="element.attributes.type == 'certificate'" style="height: 100%"> mdi-school-outline </v-icon>
                  <v-icon v-else-if="element.attributes.type == 'event'" style="height: 100%"> mdi-calendar-outline </v-icon>
                </v-col>
                <v-col cols="9" class="">
                  <v-card-subtitle class="pa-0 text-center" v-if="element.attributes.type == 'share_hub'">
                    {{ $t("shareHubAction") }}
                  </v-card-subtitle>
                  <v-card-subtitle class="pa-0 text-center" v-else-if="element.attributes.type == 'share_activity'">
                    {{ $t("shareActAction") }}
                  </v-card-subtitle>
                  <v-card-subtitle class="pa-0 text-center" v-else-if="element.attributes.type == 'delay_duration'">
                    {{ $t("delayAmountOfTimeAction") }}
                  </v-card-subtitle>
                  <v-card-subtitle class="pa-0 text-center" v-else-if="element.attributes.type == 'delay_until'">
                    {{ $t("delayUntilDateAndTimeAction") }}
                  </v-card-subtitle>
                  <v-card-subtitle class="pa-0 text-center" v-else-if="element.attributes.type == 'custom_message'">
                    {{ $t("sendCustomMessageAction") }}
                  </v-card-subtitle>
                  <v-card-subtitle class="pa-0 text-center" v-else-if="element.attributes.type == 'remove_from_hub'">
                    {{ $t("removeFromHubAction") }}
                  </v-card-subtitle>
                  <v-card-subtitle class="pa-0 text-center" v-else-if="element.attributes.type == 'remove_from_activity'">
                    {{ $t("removeFromActivityAction") }}
                  </v-card-subtitle>
                  <v-card-subtitle class="pa-0 text-center" v-else-if="element.attributes.type == 'certificate'">
                    {{ $t("certificateAction") }}
                  </v-card-subtitle>
                  <v-card-subtitle class="pa-0 text-center" v-else-if="element.attributes.type == 'event'">
                    {{ $t("eventAction") }}
                  </v-card-subtitle>
                </v-col>
              </v-row>
            </v-card>
          </div>
        </draggable>
      </div>
    </v-navigation-drawer>
    <ConfirmationDialog v-if="dialogDraftVisible" ref="confirmationDialogExit" :visible="dialogDraftVisible"
      :cd-title="confirmationDialogTitle" :cd-text="confirmationDialogText" :cd-submit-btn="confirmationDialogSubmitBtn"
      :cd-cancel-btn="confirmationDialogCancelBtn" cd-submit-btn-color="accent" data-testid="confirmation-dialog"
      @close="dialogDraftVisible = false" @proceedSubmit="discardChangesWorkflow" />
  </div>
</template>

<script>
import i18n from "../../plugins/i18n";
import draggable from "vuedraggable";
import AlertMessages from "../../components/AlertMessages";
import ShareItems from "../../components/workflow_components/ShareItems";
import { repeatedMethodsMixin } from "../../mixins/repeatedMethodsMixin";
import {
  getActionTypesWorkflow,
  addWorkflowAction,
  getWorkflowActionsInWorkflow,
  saveWorkflowActions,
  updateWorkflowAction,
  refreshWorkflowAction
} from "../../api/workflowApi";
import ConfirmationDialog from "../../components/ConfirmationDialog";
import { getActivitiesWorkflow, getOpenActivitiesWorkflow } from "../../api/activityApi";
import { getHubsWorkflow, getOpenHubsWorkflow } from "../../api/hubApi";
import { getSpaceByURL } from '../../api/spaceApi'
import {eventBus} from '../../eventbus'
import { loadGoogleMapsAPI } from '@/utils/googleMapsLoader';

export default {
  components: {
    draggable,
    AlertMessages,
    ShareItems,
    ConfirmationDialog,
  },
  mixins: [repeatedMethodsMixin],
  data() {
    return {
      alertMsg: "",
      alertType: "",
      alertValue: false,
      dragging: false,
      actionDragged: false,
      startingLength: 0,
      movingId: "",
      listActionBlocks: [],
      listItemsHtml: [],
      item: [],
      list: [],
      workflowId: this.$route.params.id,
      workflowActions: [],
      workflowAction: {},
      loading: false,
      loadingAutosave: false,
      draftVersion: false,
      draftVersionId: 0,
      dialogDraftVisible: false,
      dialogPublishVisible: false,
      confirmationDialogTitle: "",
      confirmationDialogText: "",
      confirmationDialogCancelBtn: "",
      confirmationDialogSubmitBtn: "",
      disableButtons: false,
      activities: [],
      hubs: [],
      spaceId: window.$cookies.get("space_id"),
      space: window.location.host.split('.')[0],
      updateActions: null,
      updateAction: null,
      invalidActions: [],
      showWarningUnpublishedChanges: false,
      openedPanel: null
    };
  },
  async mounted() {
    try {
      await loadGoogleMapsAPI(); 
    } catch (error) {
      console.error('Failed to load Google Maps API:', error);
    } 
  },
  computed: {
    workflow() {
      return this.$store.state.workflow
    }
  },
  watch: {
    invalidActions(){
      if(this.invalidActions.length > 0){
        this.disableButtons = true;
        eventBus.$emit('disablePublish', true)
      }else {
        this.disableButtons = false;
        eventBus.$emit('disablePublish', false)
      }
    },
    updateAction(){
      if(this.workflowActions.filter(item => item.attributes.is_active == false && item.attributes.is_deleted == false).length > 0){
        this.showWarningUnpublishedChanges = true
      }else {
        this.showWarningUnpublishedChanges = false
      }
    },
    updateActions(){
      if(this.workflowActions.filter(item => item.attributes.is_active == false && item.attributes.is_deleted == false).length > 0){
        this.showWarningUnpublishedChanges = true
      }else {
        this.showWarningUnpublishedChanges = false
      }
    }
  },

  async created() {
    eventBus.$on('changeStatus', async ()=>{
      //this.getWorkflowActionsInWorkflow();
      const response = await getWorkflowActionsInWorkflow(this.workflowId);
      for (let i = 0; i < this.workflowActions.length; i++) {
        let data = response.data.data.find(item => item.id == this.workflowActions[i].id)
        if(data){
          this.workflowActions[i] = response.data.data.find(item => item.id == this.workflowActions[i].id )
        }
      }
      this.updateAction = Date.now();
    })

    eventBus.$on('saveWorkflow',()=>{
        this.saveWorkflowActions()
    })

    this.loading = true;
    this.disableButtons = true;
    await this.getActionTypesWorkflow();
    await this.fetchActivities();
    await this.fetchHubs();
    await this.getWorkflowActionsInWorkflow();

    //check if unpublished chip should be shown or not
    if(this.workflowActions.filter(item => item.attributes.is_active == false && item.attributes.is_deleted == false).length > 0){
      this.showWarningUnpublishedChanges = true
    }else {
      this.showWarningUnpublishedChanges = false
    }
    this.disableButtons = false;
    this.loading = false;
  },
  beforeDestroy() {
    eventBus.$off('changeStatus')
    eventBus.$off('saveWorkflow')
  },
  methods: {
    async getActionTypesWorkflow() {
      try {
        const response = await getActionTypesWorkflow();
        if (response.status) {
          if (response.status == 200) {
            this.listActionBlocks = response.data.data;
          }
        }
      } catch (e) {
        if (e.response) {
          this.alertType = "error";
          this.alertMsg = i18n.t("serverError");
        }
      }
    },
    async getWorkflowActionsInWorkflow() {
      try {
        const response = await getWorkflowActionsInWorkflow(this.workflowId);
        if (response.status) {
          if (response.status == 200) {
            this.workflowActions = response.data.data;
          }
        }
      } catch (e) {
        if (e.response) {
          this.alertType = "error";
          this.alertMsg = i18n.t("serverError");
        }
      }
    },
    async createWorkflowAction(value, item, index) {
            try {
        var data = {};
        if (item.attributes.type == "share_activity") {
          data = {
            data: {
              type: "workflow-actions",
              attributes: {
                resource: value.resource,
                custom_message: value.message,
                team_type: "activity",
              },
              relationships: {
                workflow: {
                  data: {
                    type: "workflows",
                    id: this.workflowId,
                  },
                },
                "action-type": {
                  data: {
                    type: "action-types",
                    id: item.id,
                  },
                },
              },
            },
          };
        } else if (item.attributes.type == "share_hub") { 
          data = {
            data: {
              type: "workflow-actions",
              attributes: {
                resource: value.resource,
                custom_message: value.message,
                team_type: "hub",
              },
              relationships: {
                workflow: {
                  data: {
                    type: "workflows",
                    id: this.workflowId,
                  },
                },
                "action-type": {
                  data: {
                    type: "action-types",
                    id: item.id,
                  },
                },
              },
            },
          };
        }else if (item.attributes.type == "delay_duration") { 
          data = {
            data: {
              type: "workflow-actions",
              attributes: {
                delay_duration: String(value),
              },
              relationships: {
                workflow: {
                  data: {
                    type: "workflows",
                    id: this.workflowId,
                  },
                },
                "action-type": {
                  data: {
                    type: "action-types",
                    id: item.id,
                  },
                },
              },
            },
          };
        }else if (item.attributes.type == "delay_until") { 
          data = {
            data: {
              type: "workflow-actions",
              attributes: {
                delay_till_time: value,
              },
              relationships: {
                workflow: {
                  data: {
                    type: "workflows",
                    id: this.workflowId,
                  },
                },
                "action-type": {
                  data: {
                    type: "action-types",
                    id: item.id,
                  },
                },
              },
            },
          };
        }else if (item.attributes.type == "custom_message") { 
          data = {
            data: {
              type: "workflow-actions",
              attributes: {
                custom_subject: value.subject,
                custom_message: value.message
              },
              relationships: {
                workflow: {
                  data: {
                    type: "workflows",
                    id: this.workflowId,
                  },
                },
                "action-type": {
                  data: {
                    type: "action-types",
                    id: item.id,
                  },
                },
              },
            },
          };
        }else if (item.attributes.type == "remove_from_hub") {
          data = {
            data: {
              type: "workflow-actions",
              attributes: {
                resource: value.resource,
                team_type: "hub",
              },
              relationships: {
                workflow: {
                  data: {
                    type: "workflows",
                    id: this.workflowId,
                  },
                },
                "action-type": {
                  data: {
                    type: "action-types",
                    id: item.id,
                  },
                },
              },
            },
          };
        } else if (item.attributes.type == "remove_from_activity") {
          data = {
            data: {
              type: "workflow-actions",
              attributes: {
                resource: value.resource,
                team_type: "activity",
              },
              relationships: {
                workflow: {
                  data: {
                    type: "workflows",
                    id: this.workflowId,
                  },
                },
                "action-type": {
                  data: {
                    type: "action-types",
                    id: item.id,
                  },
                },
              },
            },
          };
        }else if (item.attributes.type == "certificate") { 
          data = {
            data: {
              type: "workflow-actions",
              attributes: {
                custom_subject: value.subject,
                custom_message: value.message
              },
              relationships: {
                workflow: {
                  data: {
                    type: "workflows",
                    id: this.workflowId,
                  },
                },
                "action-type": {
                  data: {
                    type: "action-types",
                    id: item.id,
                  },
                },
              },
            },
          };
        } else if (item.attributes.type == "event") {
          data = {
            data: {
              type: "workflow-actions",
              attributes: {
                event_title: value.eventTitle,
                event_type: value.eventType,
                event_has_list: value.eventHasList,
                event_data: value.eventData,
                event_tutors: value.eventHasList ? value.eventTutors : [],
                event_reminders: value.eventHasList ? value.eventReminders : [],
                event_at:  value.eventAt,
                custom_subject: value.subject,
                custom_message: value.message
              },
              relationships: {
                workflow: {
                  data: {
                    type: "workflows",
                    id: this.workflowId,
                  },
                },
                "action-type": {
                  data: {
                    type: "action-types",
                    id: item.id,
                  },
                },
              },
            },
          };
        }
        var response = await addWorkflowAction(data);
        if (response) {
          if (response.status == 201) {
                        this.invalidActions = this.invalidActions.filter(function(e) { return e !== item.id })
            this.workflowActions[index] = response.data.data
            this.updateAction = Date.now();
          }
        }
      } catch (e) {
        if (e.response) {
          this.alertValue = true;
          this.alertType = "error";
          if (e.response.status == 400) {
              for (let i = 0; i < e.response.data.errors.length; i++) {
                if (
                  e.response.data.errors[i].detail ==
                  "Duplicate Request for same workflow can not be created"
                ) {
                  this.alertMsg = i18n.t("errorWorkflowAction");
                } else {
                  this.alertMsg = i18n.t("serverError");
                }
            }
          } else if (e.response.status == 403) {
            this.$router.push({ name: "PageAccessDenied" });
          } else {
            this.alertMsg = i18n.t("serverError");
          }
        } else {
          this.alertType = "error";
          this.alertValue = true;
          this.alertMsg = i18n.t("serverError");
        }
      }
      
    },
    async editWorkflowAction(value, item, index) {
      try {
        var data = {};
        if (item.relationships['action-types'].meta.type == "share_activity") {
          data = {
            data: {
              id: item.id,
              type: "workflow-actions",
              attributes: {
                resource: value.resource,
                custom_message: value.message,
                team_type: "activity",
              },
              relationships: {
                workflow: {
                  data: {
                    type: "workflows",
                    id: this.workflowId,
                  },
                },
                "action-type": {
                  data: {
                    type: "action-types",
                    id: item.relationships["action-types"].meta.id.toString(),
                  },
                },
              },
            },
          };
        }else if (item.relationships['action-types'].meta.type == "share_hub") {
          data = {
            data: {
              id: item.id,
              type: "workflow-actions",
              attributes: {
                resource: value.resource,
                custom_message: value.message,
                team_type: "hub",
              },
              relationships: {
                workflow: {
                  data: {
                    type: "workflows",
                    id: this.workflowId,
                  },
                },
                "action-type": {
                  data: {
                    type: "action-types",
                    id: item.relationships["action-types"].meta.id.toString(),
                  },
                },
              },
            },
          };
        }else if (item.relationships['action-types'].meta.type == "delay_duration") {
          data = {
            data: {
              id: item.id,
              type: "workflow-actions",
              attributes: {
                delay_duration: String(value),
              },
              relationships: {
                workflow: {
                  data: {
                    type: "workflows",
                    id: this.workflowId,
                  },
                },
                "action-type": {
                  data: {
                    type: "action-types",
                    id: item.relationships["action-types"].meta.id.toString(),
                  },
                },
              },
            },
          };
        }else if(item.relationships['action-types'].meta.type == "delay_until") {
          data = {
            data: {
              id: item.id,
              type: "workflow-actions",
              attributes: {
                delay_till_time: value,
              },
              relationships: {
                workflow: {
                  data: {
                    type: "workflows",
                    id: this.workflowId,
                  },
                },
                "action-type": {
                  data: {
                    type: "action-types",
                    id: item.relationships["action-types"].meta.id.toString(),
                  },
                },
              },
            },
          };
        }else if(item.relationships['action-types'].meta.type == "custom_message") {
          data = {
            data: {
              id: item.id,
              type: "workflow-actions",
              attributes: {
                custom_subject: value.subject,
                custom_message: value.message
              },
              relationships: {
                workflow: {
                  data: {
                    type: "workflows",
                    id: this.workflowId,
                  },
                },
                "action-type": {
                  data: {
                    type: "action-types",
                    id: item.relationships["action-types"].meta.id.toString(),
                  },
                },
              },
            },
          };
        }else if (item.relationships['action-types'].meta.type == "remove_from_hub") {
          data = {
            data: {
              id: item.id,
              type: "workflow-actions",
              attributes: {
                resource: value.resource,
                team_type: "hub",
              },
              relationships: {
                workflow: {
                  data: {
                    type: "workflows",
                    id: this.workflowId,
                  },
                },
                "action-type": {
                  data: {
                    type: "action-types",
                    id: item.relationships["action-types"].meta.id.toString(),
                  },
                },
              },
            },
          };
        } else if (item.relationships['action-types'].meta.type == "remove_from_activity") {
          data = {
            data: {
              id: item.id,
              type: "workflow-actions",
              attributes: {
                resource: value.resource,
                team_type: "activity",
              },
              relationships: {
                workflow: {
                  data: {
                    type: "workflows",
                    id: this.workflowId,
                  },
                },
                "action-type": {
                  data: {
                    type: "action-types",
                    id: item.relationships["action-types"].meta.id.toString(),
                  },
                },
              },
            },
          };
        }else if(item.relationships['action-types'].meta.type == "certificate") {
          data = {
            data: {
              id: item.id,
              type: "workflow-actions",
              attributes: {
                custom_subject: value.subject,
                custom_message: value.message
              },
              relationships: {
                workflow: {
                  data: {
                    type: "workflows",
                    id: this.workflowId,
                  },
                },
                "action-type": {
                  data: {
                    type: "action-types",
                    id: item.relationships["action-types"].meta.id.toString(),
                  },
                },
              },
            },
          };
        } else if (item.relationships['action-types'].meta.type == "event") {
          data = {
            data: {
              id: item.id,
              type: "workflow-actions",
              attributes: {
                event_title: value.eventTitle,
                event_type: value.eventType,
                event_has_list: value.eventHasList,
                event_data: value.eventData,
                event_tutors: value.eventHasList ? value.eventTutors : [],
                event_reminders: value.eventHasList ? value.eventReminders : [],
                event_at:  value.eventAt,
                custom_subject: value.subject,
                custom_message: value.message
              },
              relationships: {
                workflow: {
                  data: {
                    type: "workflows",
                    id: this.workflowId,
                  },
                },
                "action-type": {
                  data: {
                    type: "action-types",
                    id: item.relationships["action-types"].meta.id.toString(),
                  },
                }
              },
            },
          };
        }
        var response = await updateWorkflowAction(item.id,data);
        if (response) {
          if (response.status == 200) {
            //check if broken status is fixed
            if(item.attributes.is_broken){
              this.$store.dispatch("getWorkflow", this.workflowId)
              const response_space = await getSpaceByURL(this.space) 
              this.$store.dispatch("setBrokenWorkflow", response_space.data.data.attributes.workflow_warning)
            }   
            this.invalidActions = this.invalidActions.filter(function(e) { return e !== item.id })
            this.workflowActions[index] = response.data.data;
            this.updateAction = Date.now();
          }
        }
      } catch (e) {
        if (e.response) {
          this.alertValue = true;
          this.alertType = "error";
          if (e.response.status == 400) {
            for (let i = 0; i < e.response.data.errors.length; i++) {
              for (let i = 0; i < e.response.data.errors.length; i++) {
                if (
                  e.response.data.errors[i].detail ==
                  "Duplicate Request for same workflow"
                ) {
                  this.alertMsg = i18n.t("errorWorkflowAction");
                } else {
                  this.alertMsg = i18n.t("serverError");
                }
              }
            }
          } else if (e.response.status == 403) {
            this.$router.push({ name: "PageAccessDenied" });
          } else {
            this.alertMsg = i18n.t("serverError");
          }
        } else {
          this.alertType = "error";
          this.alertValue = true;
          this.alertMsg = i18n.t("serverError");
        }
      }
    },
    endActions(evt) {
      this.item = evt;
      this.workflowActions.push(this.item);
      this.invalidActions.push(this.item.id);
    },
    addBlockToLayout(element) {
      this.item = element;
      this.workflowActions.push(this.item);
      this.invalidActions.push(this.item.id);
    },
    onEnd() {
      if(this.startingLength != this.workflowActions.length ){
        this.invalidActions.push(this.movingId);
        this.updateAction = Date.now();
      }
    },
    sortDone(){
      this.updateAction = Date.now();
    },
    dragDropBlockToPageLayout(evt) {
      // console.log('moving ', evt.attributes.name)
      this.startingLength = this.workflowActions.length;
      this.movingId = evt.id;
      return evt;
    },
    async afterDelete(item, index, deletedItem) {
      if(item.relationships){
        this.workflowActions[index]= deletedItem;
      }else{
        this.workflowActions.splice(index,1);
      }
      this.invalidActions = this.invalidActions.filter(function(e) { return e !== item.id })
      this.updateAction = Date.now();
      this.openedPanel = null
    },
    async discardChangesWorkflow() {
      this.list = [];
      let position = 0;
      for (let i = 0; i < this.workflowActions.length; i++) {
        if(this.workflowActions[i].relationships){
          this.list.push({
            id: this.workflowActions[i].id,
            position: position++,
          });
        }
      }
      try {
        let data = {
          data: {
            type: "workflow-actions",
            attributes: {
              publishing: false,
              actions: this.list,
            },
            relationships: {
              workflow: {
                data: {
                  type: "workflows",
                  id: this.workflowId,
                },
              },
            },
          },
        };

        var response = await saveWorkflowActions(this.workflowId, data);
        if (response) {
          if (response.status == 200) {
            //check if broken status is fixed
            if(this.workflow.attributes.is_broken){
              this.$store.dispatch("getWorkflow", this.workflowId)
              const response_space = await getSpaceByURL(this.space) 
              this.$store.dispatch("setBrokenWorkflow", response_space.data.data.attributes.workflow_warning)
            }      
            this.$router.push({
              name: "WorkflowOverview",
              params: {
                id: this.$route.params.id,
                discardChangesWorkflow: true,
              },
            });
             this.dialogDraftVisible = false;
          }
        }
      } catch (e) {
        if (e.response) {
          this.alertValue = true;
          this.alertType = "error";
          if (e.response.status == 400) {
              for (let i = 0; i < e.response.data.errors.length; i++) {
                if (
                  e.response.data.errors[i].detail ==
                  "Duplicate Request for same workflow can not be created"
                ) {
                  this.alertMsg = i18n.t("errorWorkflowAction");
                } else {
                  this.alertMsg = i18n.t("serverError");
                }
            }
          } else if (e.response.status == 403) {
            this.$router.push({ name: "PageAccessDenied" });
          } else {
            this.alertMsg = i18n.t("serverError");
          }
        } else {
          this.alertType = "error";
          this.alertValue = true;
          this.alertMsg = i18n.t("serverError");
        }
      }
     
    },
    async saveWorkflowActions() {
      this.list = [];
      let position = 0;
      for (let i = 0; i < this.workflowActions.length; i++) {
        if(this.workflowActions[i].relationships){
          this.list.push({
            id: this.workflowActions[i].id,
            position: position++,
          });
        }
      }
      try {
        let data = {
          data: {
            type: "workflow-actions",
            attributes: {
              publishing: true,
              actions: this.list,
            },
            relationships: {
              workflow: {
                data: {
                  type: "workflows",
                  id: this.workflowId,
                },
              },
            },
          },
        };

        var response = await saveWorkflowActions(this.workflowId, data);
        if (response) {
          if (response.status == 200) {
            //check if broken status is fixed
            if(this.workflow.attributes.is_broken){
              this.$store.dispatch("getWorkflow", this.workflowId)
              const response_space = await getSpaceByURL(this.space) 
              this.$store.dispatch("setBrokenWorkflow", response_space.data.data.attributes.workflow_warning)
            }           
            this.$router.push({
              name: "WorkflowOverview",
              params: { id: this.$route.params.id, savedChangesWorkflow: true },
            });
             this.dialogDraftVisible = false;
          }
        }
      } catch (e) {
        if (e.response) {
          this.alertValue = true;
          this.alertType = "error";
          if (e.response.status == 400) {
              for (let i = 0; i < e.response.data.errors.length; i++) {
                if (
                  e.response.data.errors[i].detail ==
                  "Duplicate Request for same workflow can not be created"
                ) {
                  this.alertMsg = i18n.t("errorWorkflowAction");
                } else {
                  this.alertMsg = i18n.t("serverError");
                }
            }
          } else if (e.response.status == 403) {
            this.$router.push({ name: "PageAccessDenied" });
          } else {
            this.alertMsg = i18n.t("serverError");
          }
        } else {
          this.alertType = "error";
          this.alertValue = true;
          this.alertMsg = i18n.t("serverError");
        }
      }
    },
    async fetchActivities() {
      try {
        var response;
        if(this.workflow.attributes.member_type == "email"){
          response = await getOpenActivitiesWorkflow(
            this.spaceId
          );
        } else {
          response = await getActivitiesWorkflow(
            this.spaceId
          );
        }
        if (response.status) {
          if (response.status == 200) {
            this.activities = response.data.data;
          }
        }
      } catch (e) {
        if (e.response) {
          if (e.response.status == 404) {
            this.$router.push({ name: "PageNotFound" });
          } else if (e.response.status == 403) {
            this.$router.push({ name: "PageAccessDenied" });
          } else {
            this.alertValue = true;
            this.alertType = "error";
            this.alertMsg = i18n.t("serverError");
          }
        }
      }
    },
    async fetchHubs() {
      try {
        var response;
        if(this.workflow.attributes.member_type == "email"){
          response = await getOpenHubsWorkflow(this.spaceId);
        } else {
          response = await getHubsWorkflow(this.spaceId);
        }
        if (response.status) {
          if (response.status == 200) {
            this.hubs = response.data.data;
          }
        }
      } catch (e) {
        if (e.response) {
          if (e.response.status == 404) {
            this.$router.push({ name: "PageNotFound" });
          } else if (e.response.status == 403) {
            this.$router.push({ name: "PageAccessDenied" });
          } else {
            this.alertValue = true;
            this.alertType = "error";
            this.alertMsg = i18n.t("serverError");
          }
        }
      }
    },
    async refreshWorkflowAction(id){
      try {
        const response = await refreshWorkflowAction(id);
        if (response.status) {
          if (response.status == 200) {           
            if(response.data.meta.code == 'restored'){
              this.workflowActions.filter(action => action.id == id)[0].attributes.is_broken = false
              if(this.workflowActions.filter(action => action.id == id)[0].relationships['action-types'].meta.type == 'share_hub'){
                await this.fetchHubs()
                this.updateActions = Date.now();
              }else{
                await this.fetchActivities();
                this.updateActions = Date.now();
              }
              //check if broken status is fixed on workflow level
              this.$store.dispatch("getWorkflow", this.workflowId)
              const response_space = await getSpaceByURL(this.space) 
              this.$store.dispatch("setBrokenWorkflow", response_space.data.data.attributes.workflow_warning)
            }
          }
        }
      } catch (e) {
        if (e.response) {
          this.alertValue = true;
          this.alertType = "error";
          this.alertMsg = i18n.t("serverError");
        }
      }
    },

    async editWorkflowActionSaveWorkflow(id, item, index){
      await this.editWorkflowAction(id, item, index)
    },


  async saveWorkflowWithoutRedirectAfterDeletion(index){
    this.list = [];
      let position = 0;
      for (let i = 0; i < this.workflowActions.length; i++) {
        this.list.push({
          id: this.workflowActions[i].id,
          position: position++,
        });
      }
      let data = {
        data: {
          type: "workflow-actions",
          attributes: {
            publishing: true,
            actions: this.list,
          },
          relationships: {
            workflow: {
              data: {
                type: "workflows",
                id: this.workflowId,
              },
            },
          },
        },
      };
      await saveWorkflowActions(this.workflowId, data)
      //check if broken status is fixed
      if(this.workflow.attributes.is_broken){
        await this.getWorkflowActionsInWorkflow();
        this.$store.dispatch("getWorkflow", this.workflowId)
        const response_space = await getSpaceByURL(this.space) 
        this.$store.dispatch("setBrokenWorkflow", response_space.data.data.attributes.workflow_warning)
      }
      this.invalidActions = this.invalidActions.filter(function(e) { return e !== this.workflowActions[index].id })

      this.workflowActions[index].attributes.is_broken = false
      this.updateActions = Date.now();
    },

  }
};

</script>

<style>
.disabled-area{
  opacity: 0.5;
}
.disabled-overlay {
  width: 92%;
  height: 100%;
  position: absolute;
  opacity: 0.3;
  z-index: 1;
  top: 10%;
}
.color-border {
  border: 2px solid var(--v-greytextlight-base);
}

.vertical {
  border-left: 2px solid var(--v-greytextlight-base);
  height: 80px;
  position: absolute;
  left: 50%;
}

.workflow-action:has(.dragArea:empty) {
  padding-top: 0px !important;
}
</style>
